import * as React from 'react';
import { graphql } from 'gatsby';
import Section from '../../components/shared/Section';
import Text from '../../components/shared/Text';
import s from './ArticleTemplate.module.scss';

export interface Props {
  id: number;
  heading: string;
  internal: {
    type: string;
  };
}

class HeadingBlock extends React.Component<Props> {
  render() {
    const { heading } = this.props;
    return (
      <div className={s.headingBlock}>
        <Text h4>{heading}</Text>
      </div>
    );
  }
}

export const query = graphql`
  fragment Article_HeadingBlockFragment on WordPressAcf_heading {
    ... on WordPressAcf_heading {
      id
      heading
      internal {
        type
      }
    }
  }
`;

export default HeadingBlock;
